import React, { useState } from "react";

import {
  Card,
  CardContent,
  Typography,
  Grid,
  Stack,
  Button,
  Box,
} from "@mui/material";

export const EducationCard = ({ icon, title, content }) => {
  const [showContent, setShowContent] = useState(false);

  return (
    <Card
      sx={{
        borderRadius: "16px",
        px: 2,
        pt: { xs: 1, sm: 2 },
        mt: 2,
        boxShadow: "4px 4px 20px 0px #0000001A",
      }}
    >
      <CardContent>
        <Grid container>
          <Grid item xs={10} sx={{ display: "flex", alignItems: "center" }}>
            <Stack direction={"row"} spacing={2} alignItems={"flex-start"}>
              <Stack alignItems={"center"}>
                <Typography
                  variant="body4"
                  onClick={() => {
                    setShowContent(!showContent);
                  }}
                  sx={{
                    fontWeight: 700,
                    cursor: "pointer",
                    color: "rgba(43, 54, 116, .6)",
                  }}
                >
                  {title}
                </Typography>
              </Stack>
            </Stack>
          </Grid>
          <Grid
            item
            xs={2}
            sx={{
              display: "flex",
              justifyContent: "end",
              alignItems: "flex-start",
            }}
          >
            {!showContent && (
              <Button
                variant="text"
                onClick={() => {
                  setShowContent(true);
                }}
                sx={{
                  minWidth: "44px",
                  width: "44px !important",
                  height: "44px",
                }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity="0.6">
                    <mask
                      id="mask0_886_29917"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="24"
                      height="24"
                    >
                      <rect width="24" height="24" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_886_29917)">
                      <path
                        d="M11.25 12.75H6.25C6.0375 12.75 5.85938 12.6781 5.71563 12.5343C5.57188 12.3904 5.5 12.2122 5.5 11.9997C5.5 11.7871 5.57188 11.609 5.71563 11.4654C5.85938 11.3218 6.0375 11.25 6.25 11.25H11.25V6.25C11.25 6.0375 11.3219 5.85938 11.4657 5.71563C11.6095 5.57188 11.7877 5.5 12.0003 5.5C12.2129 5.5 12.391 5.57188 12.5346 5.71563C12.6782 5.85938 12.7499 6.0375 12.7499 6.25V11.25H17.75C17.9625 11.25 18.1406 11.3219 18.2843 11.4657C18.4281 11.6095 18.5 11.7877 18.5 12.0003C18.5 12.2129 18.4281 12.391 18.2843 12.5346C18.1406 12.6782 17.9625 12.75 17.75 12.75H12.7499V17.75C12.7499 17.9625 12.678 18.1406 12.5342 18.2843C12.3904 18.4281 12.2122 18.5 11.9997 18.5C11.7871 18.5 11.609 18.4281 11.4654 18.2843C11.3218 18.1406 11.25 17.9625 11.25 17.75V12.75Z"
                        fill="#2B3674"
                      />
                    </g>
                  </g>
                </svg>
              </Button>
            )}
            {showContent && (
              <Button
                variant="text"
                onClick={() => {
                  setShowContent(false);
                }}
                sx={{
                  minWidth: "44px",
                  width: "44px !important",
                  height: "44px",
                }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity="0.6">
                    <mask
                      id="mask0_886_29218"
                      style={{ maskType: "alpha" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="24"
                      height="24"
                    >
                      <rect width="24" height="24" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_886_29218)">
                      <path
                        d="M5.5 12.7499V11.25H18.5V12.7499H5.5Z"
                        fill="#1C1B1F"
                      />
                    </g>
                  </g>
                </svg>
              </Button>
            )}
          </Grid>
        </Grid>

        {showContent && (
          <Typography
            variant="caption"
            sx={{
              mt: 6,
              fontSize: "14px",
              lineHeight: "18px",
              fontWeight: 400,
              color: "rgba(43, 54, 116, .6)",
            }}
          >
            {content}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};
